import { render, staticRenderFns } from "./DeveloperProfileSection.vue?vue&type=template&id=010602e6&"
import script from "./DeveloperProfileSection.vue?vue&type=script&lang=ts&"
export * from "./DeveloperProfileSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports